class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    const overlay = this.querySelector('.modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.querySelector("form").addEventListener("submit", this.onsubmit.bind(this))
    this.summaryToggle.setAttribute('role', 'button');
  }

  onsubmit() {
    window.sessionStorage.removeItem("serp_cache");
    window.sessionStorage.removeItem("serp_offsetTop");
    window.sessionStorage.removeItem("last_product_clicked_url");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if(event.target.closest('details').hasAttribute('open')) {
      this.close();
    } else {
      this.open(event);
    }
  }

  open(event) {
    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
    
    const searchInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      searchInput
    );
    
    // Ensure the search input gets focused after the modal is visible
    if (searchInput) {
      setTimeout(() => {
        searchInput.focus();
      }, 50);
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    
 
  }
}

customElements.define('details-modal', DetailsModal);
